import { useEffect, useState } from "react";
import { Play } from "lucide-react";

function vimeoId(link) {
  const m = String(link || "").match(/(\d{6,})/);
  return m ? m[1] : "";
}

export default function VideoThumb({ videoUrl, onClick, className = "", hinweis = "Video", testid }) {
  const [thumb, setThumb] = useState("");
  const [thumbOriginal, setThumbOriginal] = useState("");

  useEffect(() => {
    let aktiv = true;
    setThumb("");
    setThumbOriginal("");
    const id = vimeoId(videoUrl);
    if (!id) return;
    fetch(`https://vimeo.com/api/oembed.json?url=${encodeURIComponent(`https://vimeo.com/${id}`)}`)
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error("kein Vorschaubild"))))
      .then((d) => {
        if (aktiv && d.thumbnail_url) {
          setThumbOriginal(d.thumbnail_url);
          setThumb(d.thumbnail_url.replace(/-d_[0-9x]+/g, "-d_1920"));
        }
      })
      .catch(() => {});
    return () => {
      aktiv = false;
    };
  }, [videoUrl]);

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      className={`group relative block w-full overflow-hidden bg-navy ${className}`}
      aria-label={`${hinweis} abspielen`}
    >
      {thumb ? (
        <img
          src={thumb}
          alt=""
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
          loading="lazy"
          onError={() => {
            if (thumb !== thumbOriginal) setThumb(thumbOriginal);
          }}
        />
      ) : (
        <div className="flex h-full w-full items-center justify-center">
          <span className="text-sm text-hellblau">{hinweis}</span>
        </div>
      )}
      <span className="absolute inset-0 flex items-center justify-center bg-navy/20 transition-colors duration-300 group-hover:bg-navy/5">
        <span className="flex h-12 w-12 items-center justify-center rounded-full border border-white/60 bg-white/15 text-white backdrop-blur-sm">
          <Play size={18} fill="currentColor" strokeWidth={0} />
        </span>
      </span>
    </button>
  );
}
